import { Stack } from '@mui/material';
import { ResultRow } from '../ResultRow';
import { GazeTrackView } from './GazeTrackView';

export function GazeTest({ testDetails }) {
  const formattedValue = (val) => {
    if (!testDetails?.gazeResult) {
      return 'Cannot determine';
    }
    return val ? 'YES' : 'NO';
  };
  return (
    <>
      <Stack spacing={2}>
        {testDetails?.eyePositions && <GazeTrackView originalEyePositions={testDetails.eyePositions} />}
        <ResultRow title="Gaze Deviation Detected" value={formattedValue(testDetails.gazeResult?.gazeDeviationDetected)} />
        <ResultRow title="Gaze Palsy Detected" value={formattedValue(testDetails.gazeResult?.gazePalsyDetected)} />
        <ResultRow title="Dysconjugate Gaze Detected" value={formattedValue(testDetails.gazeResult?.dysconjugateGazeDetected)} />
      </Stack>
    </>
  );
}
